import React from 'react';
import { cn } from '../../lib/utils';
type ContainerProps = {
  children: React.ReactNode;
  className?: string;
  as?: React.ElementType;
};
export function Container({
  children,
  className,
  as: Tag = 'div'
}: ContainerProps) {
  return <Tag className={cn('mx-auto w-full max-w-content px-5 sm:px-6 lg:px-8', className)} data-id="element-470">
      {children}
    </Tag>;
}